import { useEffect, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";

function Counter({ value, suffix = "" }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 1500;
    const tick = (now) => {
      const p = Math.min(1, (now - start) / dur);
      setN(Math.floor(value * (0.2 + 0.8 * p)));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setN(value);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  return (
    <span>
      {n.toLocaleString()}
      {suffix}
    </span>
  );
}

export default function Stats() {
  const { t } = useLang();
  const [stats, setStats] = useState({
    clients_served: 120,
    projects_delivered: 240,
    countries: 14,
    automation_hours_saved: 38000,
  });

  useEffect(() => {
    api.get("/stats").then((res) => setStats(res.data)).catch(() => {});
  }, []);

  const items = [
    { value: stats.clients_served, suffix: "+", label: t.stats.clients },
    { value: stats.projects_delivered, suffix: "+", label: t.stats.projects },
    { value: stats.countries, suffix: "", label: t.stats.countries },
    { value: stats.automation_hours_saved, suffix: "+", label: t.stats.hours },
  ];

  return (
    <section className="relative border-y border-[#E5E7EB] bg-[#F9FAFB]" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-2 lg:grid-cols-4 gap-y-8">
        {items.map((it, i) => (
          <div key={i} className="flex flex-col items-start ps-4 border-s-2 border-[#FFB800]" data-testid={`stat-${i}`}>
            <div className="font-display text-4xl lg:text-5xl text-[#0B132B] tabular-nums">
              <Counter value={it.value} suffix={it.suffix} />
            </div>
            <div className="mt-1 font-mono text-[11px] uppercase tracking-widest text-[#4B5563]">
              {it.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
